<template lang="pug">
  .cover-page-container
    #cover-page.participa-page
      .layout.row.cover-header.wrap
        .flex.offset-md4.md8.xs12.title-program
          span ASU PARTICIPA
      LineMultiColorHeaderSeparator
      .layout.row.cover-body.wrap
        .flex.md4
          .logoprogram
            img.asuparticipa-logo(src="@/assets/img/asuparticipax2.png")
            .information
              router-link(:to="{ name: 'asudownload', params: { page: 'participa' } }")
                | Ver más información
        .flex.md8
          .description
            .description-header.center
              i.comillas.ap-comilla1
              h1.programs-page-title Provee <strong>asistencia técnica</strong> para generar mecanismos de <strong>participación
                | ciudadana</strong> en la estrategia
                | de <strong>gestión de inundaciones</strong>
              i.comillas.ap-comilla2
            .description-body
              h2
                | El proyecto de impacto social, ambiental y principalmente de participación, que busca incluir en el
                | diálogo a la población víctima de las crecidas del río del Paraguay, no sólo para
                | hacer frente
                | a las inundaciones, sino también en el proceso de adaptación al cambio climático.<br><br>
                | Se incluye un mapeo y estudio de las familias ubicadas en zonas de riesgo, para
                | identificar y
                | comprender los efectos y perjuicios de las inundaciones. En consecuencia,
                | la estrategia se desarrollará participativamente con un enfoque en el uso
                | eficiente de la tierra, las mejores prácticas de construcción y la gestión
                | adecuada de los residuos sólidos.
              h2
                | Los resultados contribuyen a una solución inmediata de <strong>defensa y desarrollo</strong>
                | social que contribuye al <strong>
                | <a href="/documents/PLAN_MAESTRO_FRANJA_COSTERA_2017.pdf" class="sub" target="_blank">Plan Maestro de la Franja Costera.</a></strong>
    Footer
</template>

<script>
import goToHomeMixin from '@/mixins/go-back-home.js'

export default {
  mixins: [goToHomeMixin],
  data () {
    return { dialogOpen: false }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/styles/variables'

#cover-page
  .logoprogram img
    margin-top: 2rem

  .logoprogram-title
    margin-top: -95px

.cover-header.layout.row
  height: 4.5rem

</style>
